// Local production build configuration. GitHub Actions normally injects this
// ignored file from repository secrets.
export const GOOGLE_MAPS_API_KEY_PROD = 'AIzaSyDrGtQdTHCh1zQTt6OUgibrhVLS7NvV0Vc';
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDrGtQdTHCh1zQTt6OUgibrhVLS7NvV0Vc';
export const STRIPE_STANDARD_MONTHLY_PRICE_ID = 'price_1QchBEAZjGEVNC9fP1XxnEIt';
export const STRIPE_STANDARD_YEARLY_PRICE_ID = 'price_1QchBEAZjGEVNC9fbzbNwZv3';
export const STRIPE_PRO_MONTHLY_PRICE_ID = 'price_1QchLcAZjGEVNC9fiQzY0Jjd';
export const STRIPE_PRO_YEARLY_PRICE_ID = 'price_1QchLcAZjGEVNC9fsMtYkkdq';
export const STRIPE_PUBLIC_KEY = 'pk_live_0wdXjv3PiDO45Lhu3zzNLJqz';
export const STRIPE_CLOUD_FUNCTION_BASE_URL = 'https://northamerica-northeast1-facesearchme.cloudfunctions.net/courtclic-stripe-prod';
